export default "__VITE_ASSET__F1gBJu8o__"